import { Component, EventEmitter, OnInit, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { EmailValidator, FormBuilder, FormGroup, Validators, FormArray } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as enums from '../../enums/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

//baseclasses
import { BaseEditComponent }         from '../../baseclasses/BaseEdit.component';

@Component({
  selector: 'my-fullservicepricingcustomerpackage-edit',
  templateUrl: './FullServicePricingCustomerPackageEdit.component.html',
  providers: [{provide: BaseEditComponent, useExisting: forwardRef(() => FullServicePricingCustomerPackageEditComponent)}]
})
export class FullServicePricingCustomerPackageEditComponent extends BaseEditComponent {

    displayDialog: boolean;
    
    lineItems: ent.FullServicePricingLineItem[] = [];
    pricingTypes: ent.FullServicePricingType[] = [];
    pricingTypeSelectItems: SelectItem[] = [];
    customerTypeID: number;


    @Output() onOK = new EventEmitter();

    constructor(private domainDataService: serv.DomainDataService) 
    { 
        super();
        

    }

    public load(){
      
        this.domainDataService.getFullServicePricingTypes().subscribe(x=> 
            {
                x.forEach(y=> this.pricingTypes.push(y));

                this.pricingTypeSelectItems.push({label:"", value:Constants._NONE});
                x.forEach(y=> this.pricingTypeSelectItems.push({label:y.Name, value:y.ID}));
            });
       
    }
    
    getGlobalFilterFields(): string[]{
        var fields = ['VendPackage.Name', 'VendRateAmount', 'CommissionRate', 'FullServicePricingType.Name'];
        return fields;
    }


    ngOnInit(): void {
        this.load();
    }

    onHide(){
        this.displayDialog = false;
    }

    onOKClick(event: any){
        
        this.onOK.emit();
        
        this.displayDialog = false;

    }

    pricingTypeChange(event: any, lineItem: ent.FullServicePricingLineItem){
        var pricingType = this.pricingTypes.filter(x=>x.ID == event)[0];
        if (!lineItem.FullServicePricingType || lineItem.PricingTypeID != pricingType.ID){
            lineItem.FullServicePricingType = pricingType;
            lineItem.PricingTypeID = pricingType.ID;
        }
        
    }

    showCommissionRateInput(lineItem: ent.FullServicePricingLineItem) : boolean{
        return !this.showCommissionRateDropdown(lineItem);
    }

    showCommissionRate(lineItem: ent.FullServicePricingLineItem) : boolean{
        return lineItem.CommissionRate != undefined;
    }

    showCommissionRateDropdown(lineItem: ent.FullServicePricingLineItem) : boolean{
        return lineItem.PricingTypeID == enums.FullServicePricingTypeEnum.TierOnGrid &&
            this.userInfo.AppSettings.filter(x=>x.ID == enums.AppSettingEnum.FspAllowCommissionRateSelection)[0].SettingValue == "true";
    }

    showPerformanceBasedPayLabel(lineItem: ent.FullServicePricingLineItem) : boolean{
        
        if (lineItem.PackageConfig && lineItem.PackageConfig.PerformanceBasedPay == true){
            return true;
        }
        return false;

    }

    showPricingTypeDropdown(lineItem: ent.FullServicePricingLineItem) : boolean{
        
        return !this.showPerformanceBasedPayLabel(lineItem);
        
    }

    commissionRateChange(event: any, lineItem: ent.FullServicePricingLineItem){
        
        var packageConfig = lineItem.VendPackage.PackageConfigs.filter(x=>x.ID == event)[0];
        if (!lineItem.PackageConfig || lineItem.PackageConfigID != packageConfig.ID){
            lineItem.PackageConfig = packageConfig;
            lineItem.PackageConfigID = packageConfig.ID;
            lineItem.CommissionRate = packageConfig.CommissionRate;
        }
    }
}